<template>
  <div class="wrapper">
    <p class="title text-center">{{ $t('form.editEmail')}}</p>
    <div class="content">
      <div class="current-email">
        <div class="text-message text-center">{{ $t('form.enterNewEmail')}}</div>
      </div>
      <!-- new email  -->
          <div class="form-group m-d-gruop" :class="{'mb-5':!$v.form.new_email.email || isEmailDuplicatte}">
            <vpInput
              :label="$t('common.email')"
              width="415"
              v-model="form.new_email"
              @input="onEmailTyping"
              :invalid="(!$v.form.new_email.email || isEmailDuplicatte)"
              :errMsg="!$v.form.new_email.email ? $t('validation.invalidEmail') :isEmailDuplicatte ? $t('form.emailAlreadyExists'):undefined"
              />
          </div>
          <b-spinner v-if="isEmailChanging" variant="secondary" role="status" size="sm" class="vp-input-wizard-spinner"
                :class="{'vp-input-wizard-spinner-error': isEmailDuplicatte}"/>
        <!-- </div> -->
      <!-- entity checkbox  -->
      <div class="entity-checkbox" v-if="getUserData.is_system_user" :class="{'entity-checkbox-checked':form.update_cloud}">
        <b-form-checkbox id="UpdateCloudFromEmailCheckbox" v-model="form.update_cloud" name="update_cloud">
          {{ $t('form.updateEmailAllCompanies')}}
        </b-form-checkbox>
      </div>
    </div>
    <!-- action btns  -->
    <hr class="h-line" />
    <div class="action-btns">
      <button class="submit-btn btn btn-primary" size="md" @click="onSubmit" :disabled="isDirty || isEmailDuplicatte || getLoading || (!form.new_email && !userPhone) || !$v.form.new_email.email">
        <i v-if="getLoading" class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"></i>
        <span v-else>{{ $t('common.save')}}</span>
      </button>
      <button class="btn btn-outline-danger" @click="$bvModal.hide('userEmail')">
        {{ $t('common.cancel')}}
      </button>
    </div>
  </div>
</template>

<script>
import {
  email,
  required,
} from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      curEmail: null,
      isEmailDuplicatte : false,
      submitted: false,
      isDirty : false,
      form: {
        new_email: null,
        update_cloud: false,
      },
      email_typing: false,
      isEmailChanging : false,
      userPhone : null,
    };
  },
  validations: {
    form: {
      new_email: { required, email },
    },
  },
  watch: {
    getModalState(state) {
      state && this.$bvModal.hide("userEmail");
    },
    form: {
      handler: 'checkDirty',
      deep: true,
      immediate: true
    },
  },
  computed: {
    ...mapGetters("user", [
      "getLoading",
      "getModalState",
      "getUserData",
      "getUserEmail",
      "getUserPhone",
    ]),
    ...mapGetters("authfack", ["getEmailDuplicatedCheck"]),
  },
  methods: {
    ...mapActions("user", ["changeUserEmailAction", "resetState"]),
    ...mapActions("authfack", ["checkDuplicated"]),
    checkDirty() {
      const { form, getUserEmail } = this;
      let isDirty = true;
      if ( form.new_email != getUserEmail) {
        isDirty = false;
      }else if(form.update_cloud){
        isDirty = false;
      }
      this.isDirty = isDirty;
    },
    onSubmit() {
      this.submitted = true;
      this.$v.$touch();
      this.changeUserEmailAction({
        form: {
          new_email: this.form.new_email ,
          update_cloud : this.form.update_cloud,
        },
      });
    },
    onEmailTyping() {
      if(this.$v.form.new_email.email && this.form.new_email){
        this.isEmailDuplicatte = false;
        this.isEmailChanging = true;
        setTimeout(() => {
          this.checkDuplicated({
            field: "email",
            value: this.form.new_email,
            user_id : this.getUserData.id
          }).then((res) => {
            console.log('res', res)
            this.isEmailChanging = false;
            if(!res.data.data.available){
              this.isEmailDuplicatte = true;
              this.submitted = false;
            } 
          }).catch((e) =>{
            console.log('e',e);
          })
        },500)
      }
    },
  },
  beforeMount() {
    this.resetState();
    this.form.new_email = this.getUserEmail;
    this.userPhone = this.getUserPhone;
  },
};
</script>

<style lang="scss">
  div#userEmail___BV_modal_content_ {
    .wrapper {
      .text-value {
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 15em;
      }
      .text-title {
        font-size: 20px;
        margin-bottom: 30px;
        text-align: center;
        color: rgba(96, 96, 96, 0.87);
        opacity: 0.8;
        font-weight: normal;
      }
      .err-wrapper {
        margin-left: 20px;
        padding-left: 0px;
        margin-top: 8px !important;
      }
      .h-line {
        margin-top: 40px;
        margin-bottom: 24px !important;
      }
      .text-hint {
        font-weight: normal;
        font-size: 14px;
        color: #939393;
        text-align: center;
        opacity: 0.8;
        margin-bottom: 33px;
      }
      .current-email {
        margin-bottom: 24px;
        font-family: Lato;
        font-size: 16px;
        font-weight: 400;
        line-height: 19.2px;
        letter-spacing: 0.25px;
        text-align: center;
        color: #4A4A4A;


      }


      input[type="text"] {
        background: #f2f2f2;
      }

      .row-group {
        display: flex;
        justify-content: space-between;
      }

      .entity-checkbox {
        margin-top: 24px;
        margin-bottom: 0px !important;
        font-family: Lato;
        font-size: 16px;
        font-weight: 600;
        line-height: 19.2px;
        letter-spacing: 0.25px;
        color: #787878;
      }

      .text-message{
        font-family: Lato;
        font-size: 16px;
        font-weight: 400;
        line-height: 19.2px;
        letter-spacing: 0.25px;
        text-align: center;
        color: #4A4A4A;
      }

    }

    .form-group{
      // margin-bottom: 0px !important;
    }

    .invalid-email-text{
      margin-top:0px;
    }
  }
</style>
